import { z } from 'zod/v4';
import { component } from './sceneDataSchema';

export const clientInitSchema = z.object({
  auth_result: z.object({
    quote_id: z.string().nullish(),
    access_token: z.string(),
    partner: z.string(),
    public_id: z.string(),
  }),
  configuration: z.object({
    primary_color: z.string(),
    secondary_color: z.string(),
    tertiary_color: z.string(),
    info_color: z.string().optional(),
    primary_logo_url: z.string().nullable(),
    hostedx_logo_url: z.string().nullable(),
    header_components: z.array(component),
  }),
});

export type ClientInit = z.infer<typeof clientInitSchema>;
export type PartnerBrandingConfig = z.infer<typeof clientInitSchema>['configuration'];
export type AuthResult = z.infer<typeof clientInitSchema>['auth_result'];
